import Link from '@mui/material/Link';

import { formatPhone } from 'reservations/base/helpers/phone';

export const getMaxPartySizeText = (
  emailAddress: string,
  phoneNumber: string,
  partySize: string
) => {
  const baseMessage = `For parties of ${parseFloat(partySize)} or more, please`;
  let contactMethod = 'contact us';
  let LinkComponent = null;

  if (!!phoneNumber) {
    LinkComponent = (
      <Link
        data-testid="max-party-size-phone"
        href={`tel:${phoneNumber}`}
        target="_blank"
        rel="noopener"
        underline="none"
        sx={theme => ({ color: theme.palette.soy.dark })}
      >
        {formatPhone(phoneNumber)}
      </Link>
    );
    contactMethod = `call us at `;
  } else if (!!emailAddress) {
    LinkComponent = (
      <Link
        data-testid="max-party-size-email"
        href={`mailto:${emailAddress}`}
        target="_blank"
        rel="noopener"
        underline="none"
        //istanbul ignore next
        sx={theme => ({ color: theme.palette.soy.dark })}
      >
        {emailAddress}
      </Link>
    );
    contactMethod = `email us at `;
  }

  return {
    message: `${baseMessage} ${contactMethod}`,
    LinkComponent
  };
};
